
import {API} from '@/scripts/common/api/api.services'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import settings from "@/scripts/common/settings"
import {addScrollController, refreshAllControllers} from "@/scripts/common/api/scrolltrigger.services"
gsap.registerPlugin(ScrollTrigger)

export const Social = (() => {
    class Main {
        constructor(container) {
            this.$container = container
            this.url = ""
            this.loading = false
            this.loaded = false
            this.loadingText = 'Loading...'
            this.scrollController = null
            this.APIServices = null
            this.data = null
            this.scrollOptions = {
                trigger: this.$container.dataset.trigger || this.$container,
                triggerHook: this.$container.dataset.hook || 'top bottom',
                triggerEndHook: this.$container.dataset.endHook || 'bottom top',
                offset: this.$container.dataset.offset || 0,
            }
        }

        init() {
            this.setupAPI()
            this.addCallbacks()
            this.addScrollController()
        }



        updateScrollOptions(options) {
            this.scrollOptions = Object.assign(this.scrollOptions, options)
        }

        // Callbacks

        addCallbacks() {
            this.updateScrollOptions({
                onEnter: () => {
                    this.fetchData()
                }
            })
        }

        // UI updates
        updateHTML() {
            if(this.loading) {
                this.$container.appendChild(this.loadingHTML())
                return
            }

            const $loadingHtml = this.$container.querySelector('.social-loading')
            if($loadingHtml) $loadingHtml.remove()

            if(this.listingHTML()) this.$container.appendChild(this.listingHTML())
            
        }

        loadingHTML() {
            const $loader = document.createElement('div')
            $loader.classList.add('text-center', 'social-loading')
            $loader.innerHTML = `${this.loadingText}`

            return $loader
        }

        listingHTML() {
            return false
        }

        // API
        setupAPI() {
            this.APIServices = new API.Controller()
        }
        
        async fetchData() {
            if(!this.url && this.loaded) return
            this.loading = true
            this.updateHTML()
            this.data = await this.APIServices.get(this.url)
            this.loading = false
            this.updateHTML()
        }

        addScrollController() {
            this.scrollController = ScrollTrigger.create(this.scrollOptions)
            addScrollController(this.scrollController)
        }
    }

    const DefaultOptions = {
        
    }

    return {
        Main
    }
})()